
exports.register = (ngModule) ->

    ###
     * So this is kiiiind of weird? Here's the deal.
     * Refuge needs to be handled differently than planting rows, because
     * it has to always be there, and we always want it at the bottom. it just
     * doesn't make sense for refuge to be an array item in the planting_selections!
     * It's got enough of it's own identity that it isn't 'just another row'.
     *
     * BUT, I didn't want to copy+paste all the DOM structure for the Refuge section
     * to be the same as the planting rows. SO. Here we are, using a directive to supply a
     * re-usable template!
    ###
    ngModule.directive 'rxPlantingRow', () ->
        return {
            restrict: 'E'
            scope:
                'row': '=row'
                '$index': '=index'
                'form': '=form'
                'selectOnlyOption': '=selectOnlyOption'
            link: (scope) ->
                scope.repos = scope.$parent.repos
                scope.selectCompany = scope.$parent.selectCompany
                scope.selectBrand = scope.$parent.selectBrand
                scope.disableRow = scope.$parent.disableRow

            ## Todo: move this to be templateUrl and use backend blade for this?
            template: """
                <div class="span2 product-row-label">
                    <div class='pull-right'><% row.name %></div>
                </div>

                <div class="span3 control-group"
                    ng-class="{'error': form.company<%$index%>.$invalid && !form.company<%$index%>.$pristine && row.active}"
                >
                    <ui-select
                        class="span12"
                        ng-disabled="!row.active"
                        ng-model="row.company"
                        name="company<%$index%>"
                        ng-required="row.active"
                        on-select="selectCompany(row, $item, $model)"
                        mf-auto-select-only-option="selectOnlyOption"
                        dusk='company_select_<% $index %>'
                    >
                        <ui-select-match placeholder="Select..."><% $select.selected.name %></ui-select-match>
                        <ui-select-choices repeat="item in repos.seed_companies | filter:{name: $select.search}">
                            <div ng-bind-html="item.name | highlight: $select.search"></div>
                        </ui-select-choices>
                    </ui-select>

                    <div class='animate-show control-label'
                        ng-show='form.company<%$index%>.$invalid && !form.company<%$index%>.$pristine && row.active'>
                        Seed Company is required
                    </div>
                </div>

                <div class="span3 control-group"
                    ng-class="{'error': form.brand<%$index%>.$invalid && !form.brand<%$index%>.$pristine && row.active}"
                >
                    <ui-select class="span12"
                        ng-disabled="!row.active"
                        ng-model="row.brand"
                        ng-required="row.active"
                        name="brand<%$index%>"
                        on-select="selectBrand(row, $item, $model)"
                        dusk='product_select_<% $index %>'
                    >
                        <ui-select-match placeholder="Select..."><% $select.selected.name %></ui-select-match>
                        <ui-select-choices repeat="item in row.products | filter:{name: $select.search}">
                            <div ng-bind-html="item.name | highlight: $select.search"></div>
                        </ui-select-choices>
                    </ui-select>

                    <div class='animate-show control-label'
                        ng-show='form.brand<%$index%>.$invalid && !form.brand<%$index%>.$pristine && row.active'>
                        Brand is required
                    </div>
                </div>

                <div class="span3">
                    <ui-select class="span12" ng-disabled="!row.active" ng-model="row.treatment">
                        <ui-select-match placeholder="Select..."><% $select.selected.name %></ui-select-match>
                        <ui-select-choices repeat="item in row.treatments | filter:{name: $select.search}">
                            <div ng-bind-html="item.name | highlight: $select.search"></div>
                        </ui-select-choices>
                    </ui-select>
                </div>

                <div class="span1" ng-show="$index != 0 && row.active">
                    <button class="btn btn-danger" ng-click="disableRow(row)" dusk="disable_<% $index %>">
                        <i class="fa fa-trash-alt"></i>
                    </button>
                </div>
                <div class="span1" ng-show="$index != 0 && !row.active">
                    <button class="btn btn-primary" ng-click="row.active = true" dusk="enable_<% $index %>">
                        <i class="fa fa-plus"></i>
                    </button>
                </div>
            """
        }
